<template>
  <div class="">
    <save-dialog
      :title="title"
      :dialog="dialog"
      :form="form"
      :route="route"
      :edit="edit"
      :hasMore="false"
      :more="false"
      type="sendForm"
      :bus="dialogBus"
      width="800px">
      <template slot="content">
        <template>
          <v-layout>
            <v-flex md1 pt-3>
              <v-text-field
                ref="awesompleteEmail"
                v-model="text"
                v-validate="'required|max:60'"
                maxlength="60"
                data-vv-name="subject"
                data-vv-as="asunto"
                :error-messages="errors.collect('subject')"
                label="Asunto"
                class="awesomplete"
                spellcheck="false"
                color="black"
                data-multiple>
              </v-text-field>  
            </v-flex>
            <v-flex md11>
              <v-select
                v-model="form.from"
                :items="emails"
                item-value="email"
                item-text="email"
                v-validate="'required|email|max:100'"
                data-vv-name="from"
                data-vv-as="remitente"
                :error-messages="errors.collect('from')"
                label="Remitente"
                color="black">
                <template slot="selection" slot-scope="data">
                  <div class="black--text">{{data.item.name}}&nbsp; <span class="k-grey-text">{{ ` <${data.item.email.toLowerCase()}>` }}</span></div>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title>{{data.item.name}}&nbsp; <span class="k-grey-text">{{ ` <${data.item.email.toLowerCase()}>` }}</span></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            </v-flex>
            <v-flex md1 pt-3>
              <v-btn color="black" flat icon @click="addCompanyEmail">
                <v-icon small>fas fa-plus</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md12>
              <v-text-field
                ref="awesompleteEmail"
                v-model="text"
                v-validate="'required|max:60'"
                maxlength="60"
                data-vv-name="subject"
                data-vv-as="asunto"
                :error-messages="errors.collect('subject')"
                label="Asunto"
                class="awesomplete"
                spellcheck="false"
                color="black"
                data-multiple>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <vue-editor v-model="form.text" useCustomImageHandler @imageAdded="handleImageAdded" :editorToolbar="editorToolbar"></vue-editor>
              <small class="error--text" v-if="errors.has('text')">
                {{ errors.first('text') }}
              </small>
            </v-flex>
          </v-layout>
        </template>
      </template>
    </save-dialog>
    <delete-dialog
      :text="deleteOptions.text"
      :id="deleteOptions.id"
      url="templates"
      :dialog="deleteOptions.dialog"
      :delete-bus="deleteBus">
    </delete-dialog>
    <rightDrawer
      url="/company_emails"
      content="companyEmailForm">
      <template slot="title">Añadir email nuevo</template>
    </rightDrawer>
  </div>
</template>

<script>
import Vue from 'vue';
import EventBus from '@/event-bus';
import SaveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import DeleteDialog from '@/components/global/DeleteDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import autoCompleteMixin from '@/mixins/autoComplete';
import rightDrawer from '@/components/global/RightDrawer';
import companyEmailForm from '@/components/global/sidebar_forms/CompanyEmail';
import { VueEditor } from 'vue2-editor';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';

Vue.component('companyEmailForm', companyEmailForm);

export default {
  props: {
    type: {
      type: String,
      default: 'campaign',
    },
  },
  mixins: [
    saveDialogMixin,
    autoCompleteMixin,
    emailEditorToolbarMixin,
    deleteDialogMixin,
  ],
  components: {
    SaveDialog,
    VueEditor,
    rightDrawer,
    DeleteDialog,
  },
  created() {
    EventBus.$on('createTemplateemail', () => {
      this.dialog = true;
    });
    EventBus.$on('modalOpenedTemplateemail', () => {
      this.text = '';
      this.axios.get('/company_emails?fields=email,name,id&paginate=0&status=activo').then((response) => {
        this.emails = response.data;
      });
    });
    EventBus.$on('rightDrawerSaved', () => {
      this.axios.get('/company_emails?fields=name,id,email&paginate=0&status=activo').then((response) => {
        this.emails = response.data;
        this.form.from = this.emails[this.emails.length - 1].email;
      });
    });
  },
  data() {
    return {
      route: 'templates',
      templates: [],
      emails: [],
      categories: [],
      saveCategories: [],
      form: {
        channel: 'email',
        template_code: '',
        name: '',
        from: '',
        subject: '',
        text: '',
        category: '',
        type: this.type,
      },
      isInput: true,
      text: '',
      dialogBus: {
        created: 'createdTemplateemail',
        updated: 'updatedTemplateemail',
        modalOpened: 'modalOpenedTemplateemail',
        showMore: 'showMoreTemplateemail',
        editItem: 'editItemTemplateemail',
        closeModal: 'closeModalTemplateemail',
        openRightDrawer: 'openRightDrawerTemplateemail',
      },
      deleteBus: {
        onDelete: 'deleteItemTemplateemail',
        deleted: 'deletedTemplateemail',
        canceled: 'canceledTemplateemail',
      },
      autoCompleteRef: 'awesompleteEmail',
      backdropRef: 'backdropEmail',
      highlightsRef: 'highlightsEmail',
      autoCompleteListId: 'listEmail',
      autocompleteList: [
        'nombre_completo',
        'nombre',
        'apellido',
        'monto',
        'fecha_vencimiento',
        'mañana',
        'moneda',
      ],
      fields: 'channel,template_code,name,from,subject,text,from_name,status,category',
      showName: 'plantilla email',
    };
  },
  methods: {
    addCompanyEmail() {
      EventBus.$emit('openRightDrawer');
    },
  },
  watch: {
    text(newVal) {
      this.form.subject = newVal;
    },
    'form.channel'() { // eslint-disable-line
      this.form.channel = 'email';
    },
    'form.subject'(newVal, oldVal) { // eslint-disable-line
      if (!oldVal || !newVal) {
        this.text = newVal;
      }
    },
  },
};
</script>

<style>
#backdropEmail {
  height: 30px !important;
  padding: 0 !important;
  top: 3px !important;
  background: transparent !important;
  overflow-y: hidden !important;
  overflow-x: auto !important;
}

#highlightsEmail mark {
  background: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/templateV2/FormModalEmail.vue